import React, { useState, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'

type Props = {
  src: string | false | null | undefined
  width: number
  height: number
  className?: string
  alt?: string
  style?: React.CSSProperties
}

export default function LazyImage({
  src,
  width,
  height,
  className,
  ...props
}: Props) {
  const [inViewRef, inView] = useInView()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!src) return
    if (loaded) return
    if (!inView) return
    const imageElement = new Image()
    imageElement.addEventListener('load', () => setLoaded(true))
    imageElement.src = src
    // FIXME: dont ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, src])

  const source = loaded
    ? src
    : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`

  return (
    <img
      ref={inViewRef}
      src={source ? source : undefined}
      width={width}
      height={height}
      className={classNames(className, 'transition', {
        'opacity-0': !loaded,
      })}
      {...props}
    />
  )
}
